import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { AccountData, AccountForm, adjustmentForm, ApiResponse, BudgetFundInputForm, DeleteAccountForm, deleteAdjustmentForm, fetchAdjustmentForm, UpdateAccountForm, updateAdjustmentForm } from '../../data/system/account';

@Injectable()
export class AccountService extends AccountData {

  constructor(private http: HttpClient) { super(); }

  save(param: AccountForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_save}`;
    return this.http.post<ApiResponse>(host, param).pipe(
      tap(data => {
        console.log(`account->save->data`, data);
      })
    );
  }

  // get(param: BudgetFundInputForm): Observable<ApiResponse> {
  //   const host = `${env.host}${env.endpoint.account_appropriation_get}`;
  //   const options = { withCredentials: true };
  //   return this.http.post<ApiResponse>(host, param, options).pipe(
  //     tap(data => console.log(`account->get->data`, data))
  //   );
  // }

  getSummary(param: BudgetFundInputForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_summary}`;
    return this.http.post<ApiResponse>(host, param);
  }

  update(param: UpdateAccountForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_update}`;
    return this.http.put<ApiResponse>(host, param).pipe(
      tap(data => console.log(`account->update->data`, data))
    );
  }

  delete(param: DeleteAccountForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_delete}`;
    return this.http.post<ApiResponse>(host, param).pipe(
      tap(data => console.log(`account->post->data`, data))
    );
  }

  adjustment(param: adjustmentForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_adjustment}`;
    return this.http.post<ApiResponse>(host, param).pipe(
      tap(data => console.log(`account->adjustment->data`, data))
    );
  }

  updateAdjustment(param: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_update_adjustment}`;
    return this.http.post<ApiResponse>(host, param).pipe(
      tap(data => console.log(`account->updateAdjustment->data`, data))
    );
  }

  deleteAdjustment(param: deleteAdjustmentForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_delete_adjustment}`;
    return this.http.post<ApiResponse>(host, param).pipe(
      tap(data => console.log(`account->deleteAdjustment->data`, data))
    );
  }

  fetchAdjustment(param: fetchAdjustmentForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_appropriation_fetch_adjustment}`;
    return this.http.post<ApiResponse>(host, param).pipe(
      tap(data => console.log(`account->fetchAdjustment->data`, data))
    );
  }

}
